import z from 'zod'
import {
  nullSafeOptionalBoolean,
  nullSafeOptionalString,
  nullSafeString,
  nullSafeStringArray,
} from '../shared/schema'
import { promptVersionPromptFields } from '../../types'

const promptFields = [
  ...promptVersionPromptFields,
  'participationHint',
  'llmPrompt',
] as const

export const schema = z.object({
  title: nullSafeString(''),
  description: nullSafeString(''),
  requiredFields: nullSafeStringArray([]),
  promptType: z.literal('tool_prompt'),
  showTestingTab: nullSafeOptionalBoolean(false),
  participationHint: nullSafeOptionalString(),
  requiredPrompts: z.array(z.enum(promptFields)).default(['primaryPrompt']),
  optionalPrompts: z.array(z.enum(promptFields)).default([]),
  promptSchemas: z.record(z.enum(promptFields), z.string()).default({}),
  trigger: nullSafeOptionalString(),
})

export const empty = Object.freeze(
  schema.parse({
    promptType: 'tool_prompt',
    requiredPrompts: [],
    optionalPrompts: [],
  })
)

export type FirestorePromptToolType = z.infer<typeof schema>
